import { render } from "./TaskCard.vue?vue&type=template&id=02d36c0e&scoped=true"
import script from "./TaskCard.vue?vue&type=script&lang=js"
export * from "./TaskCard.vue?vue&type=script&lang=js"

import "./TaskCard.vue?vue&type=style&index=0&id=02d36c0e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-02d36c0e"

export default script